import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

export const WarningIcon = styled(Glyphicon).attrs({
  glyph: 'warning-sign',
})`
  margin-right: 5px;
  color: #ffbf00;
`;
